export default __webpack_public_path__ + "34d3e469fcea61e501d8e8bd50908c4b.svg";